import { promiseTimeout } from '@vueuse/core';
import { ref, Ref, shallowRef } from 'vue';

/** 超时原因 */
const TIME_OUT_REASON = 'TIME_OUT_REASON';


type UseRaceParams<T> = {
  promise: Promise<T>,
  timeoutMs?: number;
};
/** 支持传入promise和timeout时间(默认10秒)
 * 返回promise的调用结果res和err，以及是否超时isTimeout, 是否执行完成isReady
 * 如果isTimeout为true，那么res和err为空
 * */
export const useRaceTimeout = <T>({ promise, timeoutMs = 10000 }: UseRaceParams<T>) => {
  const timeoutPromise = promiseTimeout(timeoutMs, true, TIME_OUT_REASON);
  const isTimeout = ref(false);
  const res: Ref<T> = shallowRef<T>(undefined as unknown as T);
  const err = ref<any>();
  const isReady = ref(false);

  Promise.race([promise, timeoutPromise])
    .then((response: any) => {
      res.value = response;
      isReady.value = true;
    })
    .catch((error) => {
      if (error === TIME_OUT_REASON) {
        isTimeout.value = true;
      } else {
        err.value = error;
      }
      isReady.value = true;
    });

  return {
    isReady,
    isTimeout,
    res,
    err,
  };
};
